import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { LoginService } from 'src/app/_clusters/services/login.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { AuthService } from 'projects/cma/src/app/pages/auth/auth-services/auth.service';


@Component({
  selector: 'app-unable-to-login',
  templateUrl: './unable-to-login.component.html',
  styleUrls: ['./unable-to-login.component.scss']
})
export class UnableToLoginComponent implements OnInit {
  fetchPassword: UntypedFormGroup;
  lms_type: any = '';
  constructor(
    //public modalRef: MDBModalRef,
    private formBuilder: UntypedFormBuilder, private loginService: LoginService,
    private router: Router, private authService: AuthService
    // private modalService: MDBModalService
  ) { }

  ngOnInit() {  window.scroll({top:0,left:0,behavior:"smooth"});
    this.lms_type = window.location.href;
    this.fetchPassword = this.formBuilder.group({
      registered_email: [''],
    });
  }
  submit() {
    this.fetchPassword.markAllAsTouched();
    if (this.fetchPassword.valid) {

      // for localhost
      // if (this.lms_type.includes('4200')) {
      //   this.unableToLoginCpa();
      // } else if (this.lms_type.includes('4300')) {
      //   this.unableToLoginCma();
      // }

      // for live or uat
      if (this.lms_type.includes('cpa')) {
        this.unableToLoginCpa();
      } else if (this.lms_type.includes('cma')) {
        this.unableToLoginCma();
      }
      else {
        this.unableToLoginfof();
      }
    }

  }
  unableToLoginCpa() {
    this.loginService.forgotPassword(this.fetchPassword.value.registered_email).subscribe((res: any) => {
      if (res) {
        Swal.fire({
          icon: res.status ? 'success' : 'error',
          text: res.message,
          allowOutsideClick: false,
        }).then((e) => {
          if (e.value) {
            if (res.status) {
              this.router.navigate(['/']);
            }
          }
        });
      }
    });

  }

  unableToLoginCma() {
    const param = { registered_email: this.fetchPassword.value.registered_email }
    this.authService.forgotPassword(param).subscribe((res: any) => {
      if (res) {
        Swal.fire({
          icon: res.status ? 'success' : 'error',
          text: res.message,
          allowOutsideClick: false,
        }).then((e) => {
          if (e.value) {
            if (res.status) {
              this.router.navigate(['/']);
            }
          }
        });
      }
    });
  }

  unableToLoginfof() {
    this.loginService.forgotfofPassword(this.fetchPassword.value.registered_email).subscribe((res: any) => {
      if (res) {
        Swal.fire({
          icon: res.status ? 'success' : 'error',
          text: res.message,
          allowOutsideClick: false,
        }).then((e) => {
          if (e.value) {
            if (res.status) {
              this.router.navigate(['/fof']);
            }
          }
        });
      }
    });
  }
}
